import { toAutoRuleMediaPlatformValue } from '#/dict/modules/FB-business/media-platform-value'
import { formatDateRange } from '#/utils'

export function toBackendInt64(
  id: number | string | undefined,
): number | undefined {
  if (typeof id === 'number') {
    return Number.isFinite(id) ? id : undefined
  }

  if (typeof id !== 'string') {
    return undefined
  }

  const trimmed = id.trim()
  if (trimmed === '') {
    return undefined
  }

  const parsed = Number(trimmed)
  return Number.isFinite(parsed) ? parsed : undefined
}

export function omitBlankString(value?: string) {
  return value === '' ? undefined : value
}

export function toAutoRuleMediaPlatform(value?: string) {
  return toAutoRuleMediaPlatformValue(omitBlankString(value))
}

export function getDateTimeRange(range?: string[]) {
  if (!range?.[0] || !range[1]) {
    return {
      end: undefined,
      start: undefined,
    }
  }

  const formatted = formatDateRange([range[0], range[1]])
  if (!formatted?.[0] || !formatted[1]) {
    return {
      end: undefined,
      start: undefined,
    }
  }

  return {
    end: formatted[1].toISOString(),
    start: formatted[0].toISOString(),
  }
}
